import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["maksuturvaForm", "paymentMethod", "invoicePopup"]

  connect() {

  }


  submit(event) {
    // Prevent the default form submission if the Maksuturva option is selected
    if (this.isMaksuturvaSelected()) {
      event.preventDefault();

      let form = this.maksuturvaFormTarget.querySelector('form')
      form.submit();
    } else if (this.isInvoiceSelected()) {
      event.preventDefault();

      let popup = this.invoicePopupTarget.querySelector('div[data-controller="popup"]')
      popup.classList.remove("hidden")
    }
    // Otherwise, allow the normal form submission
  }

  isMaksuturvaSelected() {
    return this.paymentMethodTargets.find(radio => radio.value === "web_bank" && radio.checked) !== undefined;
  }

  isInvoiceSelected() {
    return this.paymentMethodTargets.find(radio => radio.value === "invoice" && radio.checked) !== undefined;
  }
}
